<kendo-dialog *ngIf="dialogOpened" (close)="cancelDialog();" [width]="500">
    <kendo-dialog-titlebar>
        <h3>{{ 'CONFIRM-ADDRESS-TITLE' | translate}}</h3>
    </kendo-dialog-titlebar>
    <div>{{'CONFIRM-ADDRESS-REVIEW' | translate}}</div>
    <form novalidate [formGroup]="addressForm" class="k-form">
        <div class="address-container pointer" (click)="addressConfirmation.setValue('original')"
            [ngClass]="{'address-container-selected': addressConfirmation.value === 'original'}">
            <input type="radio" value="original" name="addressConfirmation" formControlName="addressConfirmation"
                id="currentAddress" kendoRadioButton />
            <label class="k-radio-label" for="currentAddress">{{'CONFIRM-ADDRESS-ENTERED' | translate}}</label>
            <div class="mt-2">
                <div class="address-line" *ngIf="currentAddressLine1 !== null && currentAddressLine1 !== ''">
                    {{currentAddressLine1}}
                </div>
                <div class="address-line" *ngIf="currentAddressLine2 !== null && currentAddressLine2 !== ''">
                    {{currentAddressLine2}}
                </div>
                <div class="address-line" *ngIf="currentAddressLine3 !== null && currentAddressLine3 !== ''">
                    {{currentAddressLine3}}
                </div>
            </div>
        </div>
        <div *ngIf="showRecommendation" class="address-container pointer mt-3"
            (click)="addressConfirmation.setValue('recommended')"
            [ngClass]="{'address-container-selected': addressConfirmation.value === 'recommended'}">
            <input type="radio" value="recommended" name="addressConfirmation" formControlName="addressConfirmation"
                id="recommendedAddress" kendoRadioButton />
            <label class="k-radio-label" for="recommendedAddress">{{'CONFIRM-ADDRESS-RECOMMENDED' | translate}}</label>
            <div class="mt-2">
                <div class="address-line" *ngIf="recommendedAddressLine1 !== null && recommendedAddressLine1 !== ''">
                    {{recommendedAddressLine1}}
                </div>
                <div class="address-line" *ngIf="recommendedAddressLine2 !== null && recommendedAddressLine2 !== ''">
                    {{recommendedAddressLine2}}
                </div>
                <div class="address-line" *ngIf="recommendedAddressLine3 !== null && recommendedAddressLine3 !== ''">
                    {{recommendedAddressLine3}}
                </div>
            </div>
        </div>
        <div *ngIf="!addressCompleted">
            <label class="mt-2">{{'VERIFICATION-ISSUES' | translate}}</label>
            <div class="address-container-errors">
                <div *ngFor="let item of missingComponentTypes">
                    <i class="fas fa-exclamation-triangle icon-warn mr-2"></i>
                    <ng-template [ngTemplateOutlet]="invalidTemplate"
                        [ngTemplateOutletContext]="{item: item, key: 'ADDRESS-ERROR-MISSING'}">
                    </ng-template>
                </div>
                <div *ngFor="let item of unconfirmedComponentTypes">
                    <i class="fas fa-exclamation-triangle icon-warn mr-2"></i>
                    <ng-template [ngTemplateOutlet]="invalidTemplate"
                        [ngTemplateOutletContext]="{item: item, key: 'ADDRESS-ERROR-UNCONFIRMED'}">
                    </ng-template>
                </div>
            </div>
        </div>
    </form>
    <kendo-dialog-actions>
        <button kendoButton (click)="cancelDialog()">{{ 'CANCEL' | translate }}</button>
        <button appPreventClick kendoButton (click)="confirm()" [primary]="true" [disabled]="addressForm.invalid">
            {{ 'CONFIRM' | translate }}
        </button>
    </kendo-dialog-actions>
</kendo-dialog>

<!--Invalid address template to handle Missing or Unconfirmed messages-->
<ng-template #invalidTemplate let-item='item' let-key='key'>
    <span [ngSwitch]="item">
        <span *ngSwitchCase="'route'"><span translate [translateParams]="{reason: textErrorStreet}">{{key}}</span>
        </span>
        <span *ngSwitchCase="'street_number'"><span translate
                [translateParams]="{reason: textErrorStreetNumber}">{{key}}</span>
        </span>
        <span *ngSwitchCase="'locality'"><span translate [translateParams]="{reason: textErrorCity}">{{key}}</span>
        </span>
        <span *ngSwitchCase="'administrative_area_level_1'"><span translate
                [translateParams]="{reason: textErrorState}">{{key}}</span>
        </span>

        <span *ngSwitchCase="'postal_code_suffix'"><span translate
                [translateParams]="{reason: textErrorZipSuffix}">{{key}}</span>
        </span>
        <span *ngSwitchCase="'postal_code'"><span translate [translateParams]="{reason: textErrorZip}">{{key}}</span>
        </span>
        <span *ngSwitchCase="'premise'"><span translate [translateParams]="{reason: textErrorPremise}">{{key}}</span>
        </span>
        <span *ngSwitchCase="'subpremise'"><span translate [translateParams]="{reason: textErrorPremise}">{{key}}</span>
        </span>
        <span *ngSwitchCase="'point_of_interest'"><span translate
                [translateParams]="{reason: textPointOfInterest}">{{key}}</span>
        </span>
        <!--Catch all will show raw value for now-->
        <span *ngSwitchDefault><span translate [translateParams]="{reason: item}">{{key}}</span>
        </span>
    </span>
</ng-template>